module.exports = __webpack_public_path__ + "img/qrcode.2fb05ecf.png";